import {
    besoinsLogementSociaux,
    caracteristiqueHlm,
    caracteristiqueSocioDemographique,
    caracteristiqueSociologique,
    dynamisme,
    financement,
    localisation,
    loyersLogementPLUSPLAI,
    parcSocial,
    repartitionPatrimoine,
} from "./InterfaceTerritoire";

//import data from './prototypeDataTerritoire';
import * as _ from "lodash";

const column = ["DE", "AT", "ATRPLS", "PA", "ON"];

export default class ficheClass {
    caracteristiqueHlm = new caracteristiqueHlm();
    caracteristiqueSociologique = new caracteristiqueSociologique();
    financement = new financement();
    localisation = new localisation();
    loyersLogementPLUSPLAI = new loyersLogementPLUSPLAI();
    repartitionPatrimoine = new repartitionPatrimoine();
    queryString = window.location.search;
    urlParams = new URLSearchParams(this.queryString);
    year = this.urlParams.get("year");
    //function pickCard(x: {suit: string; card: number; }[]): number;
    //function pickCard(x: number): {suit: string; card: number; };
    assignDE_AT_PA_OF(source: any, data: any, dataSubKey: string) {
        if (this.year === "2017") {
            if (_.has(source, "DE") && _.has(data, "DE"))
                source.DE = data.DE[dataSubKey];
            if (_.has(source, "AT") && _.has(data, "AT")) {
                source.AT = data.AT[dataSubKey];
            }
            if (_.has(source, "PA") && _.has(data, "PA"))
                source.PA = data.PA[dataSubKey];
            if (_.has(source, "ON") && _.has(data, "ON"))
                source.ON = data.ON[dataSubKey];
        } else {
            if (_.has(source, "DE") && _.has(data, "DE"))
                source.DE = parseFloat(data.DE[dataSubKey]);
            if (
                (_.has(source, "ATRPLS") && _.has(data, "ATRPLS")) ||
                (_.has(source, "AT") &&
                    _.has(data, "AT") &&
                    (data.ATRPLS || data.AT))
            ) {
                if (
                    Math.round(
                        parseFloat((data.ATRPLS || data.AT)[dataSubKey])
                    ) !== parseFloat((data.ATRPLS || data.AT)[dataSubKey])
                ) {
                    source.AT = parseFloat(
                        (data.ATRPLS || data.AT)[dataSubKey]
                    ).toFixed(2);
                } else {
                    source.AT = parseFloat(
                        (data.ATRPLS || data.AT)[dataSubKey]
                    );
                }
            }

            if (_.has(source, "PA") && _.has(data, "PA")) {
                if (
                    Math.round(parseFloat(data.PA[dataSubKey])) !==
                    parseFloat(data.PA[dataSubKey])
                ) {
                    source.PA = parseFloat(data.PA[dataSubKey]).toFixed(2);
                } else {
                    source.PA = parseFloat(data.PA[dataSubKey]);
                }
            }
            if (_.has(source, "ON") && _.has(data, "ON")) {
                if (
                    Math.round(parseFloat(data.ON[dataSubKey])) !==
                    parseFloat(data.ON[dataSubKey])
                ) {
                    source.ON = parseFloat(data.ON[dataSubKey]).toFixed(2);
                } else {
                    source.ON = parseFloat(data.ON[dataSubKey]);
                }
            }
        }
    }

    assignDE_AT_PA_OFRatio(
        source: any,
        dataNumerator: any,
        dataNumeratorSubKey: string,
        dataDenominator: any,
        dataDenominatorSubKey: string,
        getAT: boolean = false
    ) {
        if (
            _.has(source, "DE") &&
            _.has(dataNumerator, "DE") &&
            dataDenominator &&
            _.has(dataDenominator, "DE") &&
            Number(dataDenominator.DE[dataDenominatorSubKey])
        )
            source.DE =
                Number(dataNumerator.DE[dataNumeratorSubKey]) /
                Number(dataDenominator.DE[dataDenominatorSubKey]);
        if (this.year === "2017" || getAT) {
            if (
                _.has(source, "AT") &&
                _.has(dataNumerator, "AT") &&
                dataDenominator &&
                _.has(dataDenominator, "AT") &&
                Number(dataDenominator.AT[dataDenominatorSubKey])
            )
                source.AT =
                    Number(dataNumerator.AT[dataNumeratorSubKey]) /
                    Number(dataDenominator.AT[dataDenominatorSubKey]);
        } else {
            if (
                _.has(source, "ATRPLS") &&
                _.has(dataNumerator, "ATRPLS") &&
                dataDenominator &&
                _.has(dataDenominator, "ATRPLS") &&
                Number(dataDenominator.ATRPLS[dataDenominatorSubKey])
            )
                source.AT =
                    Number(dataNumerator.ATRPLS[dataNumeratorSubKey]) /
                    Number(dataDenominator.ATRPLS[dataDenominatorSubKey]);
        }
        if (
            _.has(source, "PA") &&
            _.has(dataNumerator, "PA") &&
            dataDenominator &&
            _.has(dataDenominator, "PA") &&
            Number(dataDenominator.PA[dataDenominatorSubKey])
        )
            source.PA =
                Number(dataNumerator.PA[dataNumeratorSubKey]) /
                Number(dataDenominator.PA[dataDenominatorSubKey]);
        if (
            _.has(source, "ON") &&
            _.has(dataNumerator, "ON") &&
            dataDenominator &&
            _.has(dataDenominator, "ON") &&
            Number(dataDenominator.ON[dataDenominatorSubKey])
        )
            source.ON =
                Number(dataNumerator.ON[dataNumeratorSubKey]) /
                Number(dataDenominator.ON[dataDenominatorSubKey]);
    }

    assignDE_AT_PA_OFRatioSpecific(
        source: any,
        dataNumerator: any,
        dataNumeratorSubKey: string,
        dataDenominatorDE: any,
        dataDenominatorAT: any,
        dataDenominatorPA: any,
        dataDenominatorON: any
    ) {
        if (
            _.has(source, "DE") &&
            _.has(dataNumerator, "DE") &&
            Number(dataDenominatorDE)
        )
            source.DE =
                Number(dataNumerator.DE[dataNumeratorSubKey]) /
                Number(dataDenominatorDE);
        if (
            _.has(source, "AT") &&
            _.has(dataNumerator, "AT") &&
            Number(dataDenominatorAT)
        )
            source.AT =
                Number(dataNumerator.AT[dataNumeratorSubKey]) /
                Number(dataDenominatorAT);
        if (
            _.has(source, "PA") &&
            _.has(dataNumerator, "PA") &&
            Number(dataDenominatorPA)
        )
            source.PA =
                Number(dataNumerator.PA[dataNumeratorSubKey]) /
                Number(dataDenominatorPA);
        if (
            _.has(source, "ON") &&
            _.has(dataNumerator, "ON") &&
            Number(dataDenominatorON)
        ) {
            source.ON =
                Number(dataNumerator.ON[dataNumeratorSubKey]) /
                Number(dataDenominatorON);
        }
    }

    assignDE_AT_PA_OFWithTauxRotationTauxCroissance(
        source: any,
        data: any,
        dataSubKey: string
    ) {
        this.assignDE_AT_PA_OF(source, data, dataSubKey);
        if (_.has(data, "AT") && _.has(data, "PA") && Number(data.PA.nb))
            source.tauxRotation =
                Number((data?.ATRPLS || data?.AT)?.nb) / Number(data.PA.nb);
        else source.tauxRotation = "";

        if (_.has(data, "ON") && _.has(data, "PA") && Number(data.PA.nb))
            source.tauxCroissance = Number(data.ON.nb) / Number(data.PA.nb);
        else source.tauxCroissance = "";
    }

    assignDE_AT_PA_OFRatioWithTauxRotationTauxCroissance(
        source: any,
        dataNumerator: any,
        dataNumeratorSubKey: string,
        dataDenominator: any,
        dataDenominatorSubKey: string
    ) {
        this.assignDE_AT_PA_OFRatio(
            source,
            dataNumerator,
            dataNumeratorSubKey,
            dataDenominator,
            dataDenominatorSubKey
        );
        if (
            dataNumerator?.AT &&
            dataNumerator?.AT?.nb &&
            dataNumerator?.PA &&
            dataNumerator?.PA?.nb
        )
            source.tauxRotation =
                Number(dataNumerator?.AT?.nb) / Number(dataNumerator?.PA?.nb);
        else source.tauxRotation = "";

        if (
            dataNumerator?.ON &&
            dataNumerator?.ON?.nb &&
            dataNumerator?.PA &&
            dataNumerator?.PA?.nb
        )
            source.tauxCroissance =
                Number(dataNumerator?.ON?.nb) / Number(dataNumerator.PA.nb);
        else source.tauxCroissance = "";
    }

    assignDE_AT_PA_OFRatioWithTauxRotationTauxCroissanceONdivide3(
        source: any,
        dataNumerator: any,
        dataNumeratorSubKey: string,
        dataDenominator: any,
        dataDenominatorSubKey: string
    ) {
        this.assignDE_AT_PA_OFRatio(
            source,
            dataNumerator,
            dataNumeratorSubKey,
            dataDenominator,
            dataDenominatorSubKey
        );
        if (
            (dataNumerator?.ATRPLS || dataNumerator?.AT) &&
            (dataNumerator?.ATRPLS || dataNumerator?.AT).nb &&
            dataNumerator?.PA &&
            dataNumerator?.PA?.nb
        )
            source.tauxRotation =
                Number((dataNumerator?.ATRPLS || dataNumerator?.AT)?.nb) /
                Number(dataNumerator.PA.nb);
        else source.tauxRotation = "";

        if (
            dataNumerator?.ON &&
            dataNumerator?.ON?.nb &&
            dataNumerator?.PA &&
            dataNumerator?.PA?.nb
        )
            source.tauxCroissance =
                Number(dataNumerator.ON.nb) / Number(dataNumerator.PA.nb);
        else source.tauxCroissance = "";

        if (this.year === "2017") {
            source.ON = source.ON / 3;
            source.tauxCroissance = source.tauxCroissance / 3;
        }
    }

    assignDE_AT_PA_OFRatioWithTauxRotationTauxCroissanceONdivide3Specific(
        source: any,
        dataNumerator: any,
        dataNumeratorSubKey: string,
        dataDenominatorDE: any,
        dataDenominatorAT: any,
        dataDenominatorPA: any,
        dataDenominatorON: any
    ) {
        if (this.year === "2020") {
            dataDenominatorON /= 3;
        }
        this.assignDE_AT_PA_OFRatioSpecific(
            source,
            dataNumerator,
            dataNumeratorSubKey,
            dataDenominatorDE,
            dataDenominatorAT,
            dataDenominatorPA,
            dataDenominatorON
        );
        if (
            dataNumerator?.AT &&
            dataNumerator?.AT?.nb &&
            dataNumerator?.PA &&
            Number(dataNumerator?.PA?.nb)
        )
            source.tauxRotation =
                Number(dataNumerator?.AT?.nb) / Number(dataNumerator?.PA?.nb);
        else source.tauxRotation = "";

        if (
            dataNumerator?.ON &&
            dataNumerator?.ON?.nb &&
            dataNumerator?.PA &&
            Number(dataNumerator?.PA?.nb)
        )
            source.tauxCroissance =
                Number(dataNumerator?.ON?.nb) / Number(dataNumerator?.PA?.nb);
        else source.tauxCroissance = "";

        source.ON = source.ON / 3;
        source.tauxCroissance = source?.tauxCroissance / 3;
    }

    addition(array: any[], dataSubKey: string): any[] {
        let retour: any;
        retour = {};

        _.forEach(column, function (o1: string) {
            retour[o1] = {};
            retour[o1][dataSubKey] = 0;
            _.forEach(array, function (o2: any) {
                if (_.has(o2, o1)) {
                    //let columnSum = retour[o1];
                    retour[o1][dataSubKey] += Number(o2[o1][dataSubKey]);
                }
            });
        });

        return retour;
    }

    soustraction(array: any[], dataSubKey: string): any[] {
        let retour: any;
        retour = {};

        if (array && array.length) {
            _.forEach(column, function (o1: string) {
                if (_.has(array[0], o1)) {
                    retour[o1] = {};
                    retour[o1][dataSubKey] = array[0][o1][dataSubKey] * 2;
                    _.forEach(array, function (o2: any) {
                        if (_.has(o2, o1)) {
                            //let columnSum = retour[o1];
                            retour[o1][dataSubKey] -= Number(
                                o2[o1][dataSubKey]
                            );
                        }
                    });
                }
            });
        }
        return retour;
    }

    convertString2Percent(source: any, nbTown: number) {
        if (this.year === "2017") {
            if (_.has(source, "DE")) source.DE = parseFloat(source?.DE) / 100;
            if (_.has(source, "AT")) source.AT = parseFloat(source?.AT) / 100;
            if (_.has(source, "PA")) source.PA = parseFloat(source?.PA) / 100;
            if (_.has(source, "ON")) source.ON = parseFloat(source?.ON) / 100;
        } else {
            if (_.has(source, "DE"))
                source.DE = parseFloat(source?.DE) / (nbTown * 100);
            if (_.has(source, "AT"))
                source.AT = parseFloat(source?.AT) / (nbTown * 100);
            if (_.has(source, "PA"))
                source.PA = parseFloat(source?.PA) / (nbTown * 100);
            if (_.has(source, "ON"))
                source.ON = parseFloat(source?.ON) / (nbTown * 100);
        }
    }

    constructor(data: any) {
        this.assignDE_AT_PA_OFWithTauxRotationTauxCroissance(
            this.caracteristiqueHlm?.nombre,
            data.caracteristiqueHlm?.nombre,
            "nb"
        );
        let tmpNombre = this.addition(
            [
                data.caracteristiqueHlm?.nombreHorsQPV,
                data.caracteristiqueHlm?.nombreQPV,
            ],
            "nb"
        ); //this.soustraction([data.caracteristiqueHlm.nombre, data.caracteristiqueHlm.nombreNsp], "nb");
        this.assignDE_AT_PA_OFRatioWithTauxRotationTauxCroissanceONdivide3(
            this.caracteristiqueHlm?.nombreHorsQPV,
            data.caracteristiqueHlm?.nombreHorsQPV,
            "nb",
            tmpNombre,
            "nb"
        );
        this.assignDE_AT_PA_OFRatioWithTauxRotationTauxCroissanceONdivide3(
            this.caracteristiqueHlm?.nombreQPV,
            data.caracteristiqueHlm?.nombreQPV,
            "nb",
            tmpNombre,
            "nb"
        );
        if (this.year === "2017") {
            this.caracteristiqueHlm.nombreHorsQPV.ON =
                this.caracteristiqueHlm?.nombreHorsQPV?.ON / 3;
            this.caracteristiqueHlm.nombreQPV.ON =
                this.caracteristiqueHlm?.nombreQPV?.ON / 3;
        } else {
            this.caracteristiqueHlm.nombreHorsQPV.ON = (this.caracteristiqueHlm?.nombreHorsQPV?.ON) ? (this.caracteristiqueHlm?.nombreHorsQPV?.ON).toFixed(
                2
            ) : null;
            this.caracteristiqueHlm.nombreQPV.ON = (this.caracteristiqueHlm?.nombreQPV?.ON)? (this.caracteristiqueHlm?.nombreQPV?.ON).toFixed(
                2
            ) : null;
        }
        this.caracteristiqueHlm.nombreHorsQPV.tauxCroissance =
            this.caracteristiqueHlm?.nombreHorsQPV?.tauxCroissance / 3;
        this.caracteristiqueHlm.nombreQPV.tauxCroissance =
            this.caracteristiqueHlm?.nombreQPV?.tauxCroissance / 3;

        this.assignDE_AT_PA_OFRatioWithTauxRotationTauxCroissanceONdivide3(
            this.caracteristiqueHlm?.T1,
            data.caracteristiqueHlm?.T1,
            "nb",
            data.caracteristiqueHlm?.nombre,
            "nb"
        );
        this.assignDE_AT_PA_OFRatioWithTauxRotationTauxCroissanceONdivide3(
            this.caracteristiqueHlm?.T2,
            data.caracteristiqueHlm?.T2,
            "nb",
            data.caracteristiqueHlm?.nombre,
            "nb"
        );
        this.assignDE_AT_PA_OFRatioWithTauxRotationTauxCroissanceONdivide3(
            this.caracteristiqueHlm?.T3,
            data.caracteristiqueHlm?.T3,
            "nb",
            data.caracteristiqueHlm?.nombre,
            "nb"
        );
        this.assignDE_AT_PA_OFRatioWithTauxRotationTauxCroissanceONdivide3(
            this.caracteristiqueHlm?.T4,
            data.caracteristiqueHlm?.T4,
            "nb",
            data.caracteristiqueHlm?.nombre,
            "nb"
        );
        this.assignDE_AT_PA_OFRatioWithTauxRotationTauxCroissanceONdivide3(
            this.caracteristiqueHlm?.T5Plus,
            data.caracteristiqueHlm?.T5Plus,
            "nb",
            data.caracteristiqueHlm?.nombre,
            "nb"
        );

        // calcul spécifique pour les AT
        this.assignDE_AT_PA_OFRatioSpecific(
            this.financement?.nonReserve,
            data?.financement?.nonReserve,
            "nb",
            null,
            data?.caracteristiqueHlm?.nombre?.ATRPLS?.nb,
            data?.caracteristiqueHlm?.nombre?.PA?.nb,
            data?.caracteristiqueHlm?.nombre?.ON?.nb
        );
        this.financement.nonReserve.ON = this.financement?.nonReserve?.ON / 3;

        this.assignDE_AT_PA_OFRatioWithTauxRotationTauxCroissanceONdivide3Specific(
            this.financement?.PLAI,
            data.financement?.PLAI,
            "nb",
            null,
            data.caracteristiqueHlm?.nombre?.ATRPLS?.nb,
            data.caracteristiqueHlm?.nombre?.PA?.nb,
            data.caracteristiqueHlm?.nombre?.ON?.nb
        );
        this.assignDE_AT_PA_OFRatioWithTauxRotationTauxCroissanceONdivide3Specific(
            this.financement?.PLUS,
            data.financement?.PLUS,
            "nb",
            null,
            data.caracteristiqueHlm?.nombre?.ATRPLS?.nb,
            data.caracteristiqueHlm?.nombre?.PA?.nb,
            data.caracteristiqueHlm?.nombre?.ON?.nb
        );
        this.assignDE_AT_PA_OFRatioWithTauxRotationTauxCroissanceONdivide3Specific(
            this.financement?.PLS,
            data.financement?.PLS,
            "nb",
            null,
            data.caracteristiqueHlm?.nombre?.ATRPLS?.nb,
            data.caracteristiqueHlm?.nombre?.PA?.nb,
            data.caracteristiqueHlm?.nombre?.ON?.nb
        );
        this.assignDE_AT_PA_OFRatioWithTauxRotationTauxCroissanceONdivide3Specific(
            this.financement?.PLI,
            data.financement?.PLI,
            "nb",
            null,
            data.caracteristiqueHlm?.nombre?.ATRPLS?.nb,
            data.caracteristiqueHlm?.nombre?.PA?.nb,
            data.caracteristiqueHlm?.nombre?.ON?.nb
        );

        this.assignDE_AT_PA_OF(
            this.loyersLogementPLUSPLAI?.loyerPratique,
            data.loyersLogementPLUSPLAI?.loyerPratique,
            "euros"
        );
        this.assignDE_AT_PA_OF(
            this.loyersLogementPLUSPLAI?.loyerPratiqueHorsQPV,
            data.loyersLogementPLUSPLAI?.loyerPratiqueHorsQPV,
            "euros"
        );
        this.assignDE_AT_PA_OF(
            this.loyersLogementPLUSPLAI?.loyerPratiqueQPV,
            data.loyersLogementPLUSPLAI?.loyerPratiqueQPV,
            "euros"
        );
        this.assignDE_AT_PA_OFRatio(
            this.loyersLogementPLUSPLAI?.loyerPratiqueInf55,
            data.loyersLogementPLUSPLAI?.loyerPratiqueInf55,
            "nb",
            data.loyersLogementPLUSPLAI?.loyerNonVide,
            "nb",
            true
        );
        this.assignDE_AT_PA_OFRatio(
            this.loyersLogementPLUSPLAI?.loyerPratiqueInf55HorsQPV,
            data.loyersLogementPLUSPLAI?.loyerPratiqueInf55HorsQPV,
            "nb",
            data.loyersLogementPLUSPLAI?.loyerNonVideHorsQPV,
            "nb",
            true
        );
        this.assignDE_AT_PA_OFRatio(
            this.loyersLogementPLUSPLAI?.loyerPratiqueInf55QPV,
            data.loyersLogementPLUSPLAI?.loyerPratiqueInf55QPV,
            "nb",
            data.loyersLogementPLUSPLAI?.loyerNonVideQPV,
            "nb",
            true
        );

        let tmpLoyerPratiqueInf4 = this.addition(
            [
                data.loyersLogementPLUSPLAI?.loyerPratiqueInf3,
                data.loyersLogementPLUSPLAI?.loyerPratiqueEntre3et35,
                data.loyersLogementPLUSPLAI?.loyerPratiqueEntre35et4,
            ],
            "nb"
        );
        let tmpLoyerPratiqueEntre4et5 = this.addition(
            [
                data.loyersLogementPLUSPLAI?.loyerPratiqueEntre4et45,
                data.loyersLogementPLUSPLAI?.loyerPratiqueEntre45et5,
            ],
            "nb"
        );
        let tmpLoyerPratiqueEntre5et6 = this.addition(
            [
                data.loyersLogementPLUSPLAI?.loyerPratiqueEntre5et55,
                data.loyersLogementPLUSPLAI?.loyerPratiqueEntre55et6,
            ],
            "nb"
        );
        let tmpLoyerPratiqueEntre6et7 = this.addition(
            [
                data.loyersLogementPLUSPLAI?.loyerPratiqueEntre6et65,
                data.loyersLogementPLUSPLAI?.loyerPratiqueEntre65et7,
            ],
            "nb"
        );

        this.assignDE_AT_PA_OFRatio(
            this.loyersLogementPLUSPLAI?.loyerPratiqueInf4,
            tmpLoyerPratiqueInf4,
            "nb",
            data.loyersLogementPLUSPLAI?.loyerNonVide,
            "nb",
            true
        );
        this.assignDE_AT_PA_OFRatio(
            this.loyersLogementPLUSPLAI?.loyerPratiqueEntre4et5,
            tmpLoyerPratiqueEntre4et5,
            "nb",
            data.loyersLogementPLUSPLAI?.loyerNonVide,
            "nb",
            true
        );
        this.assignDE_AT_PA_OFRatio(
            this.loyersLogementPLUSPLAI?.loyerPratiqueEntre5et6,
            tmpLoyerPratiqueEntre5et6,
            "nb",
            data.loyersLogementPLUSPLAI?.loyerNonVide,
            "nb",
            true
        );
        this.assignDE_AT_PA_OFRatio(
            this.loyersLogementPLUSPLAI?.loyerPratiqueEntre6et7,
            tmpLoyerPratiqueEntre6et7,
            "nb",
            data.loyersLogementPLUSPLAI?.loyerNonVide,
            "nb",
            true
        );
        this.assignDE_AT_PA_OFRatio(
            this.loyersLogementPLUSPLAI?.loyerPratiqueSup7,
            data.loyersLogementPLUSPLAI?.loyerPratiqueSup7,
            "nb",
            data.loyersLogementPLUSPLAI?.loyerNonVide,
            "nb",
            true
        );

        let tmpDenominateurDE = null;
        if (
            data.caracteristiqueHlm?.nombre &&
            data.caracteristiqueHlm?.nombre?.DE &&
            data.caracteristiqueHlm?.nombre?.DE?.nb
        ) {
            tmpDenominateurDE = data.caracteristiqueHlm.nombre.DE.nb;
        }
        this.assignDE_AT_PA_OFRatioSpecific(
            this.caracteristiqueSociologique?.inf30ans,
            data.caractSociologique?.inf30ans,
            "nb",
            tmpDenominateurDE,
            data.caractSociologique?.enmennageRecent?.AT?.nb,
            data.caractSociologique?.reponseOPS?.PA?.nb,
            null
        );
        this.assignDE_AT_PA_OFRatioSpecific(
            this?.caracteristiqueSociologique?.sup65ans,
            data?.caractSociologique?.sup65ans,
            "nb",
            tmpDenominateurDE,
            data.caractSociologique?.enmennageRecent?.AT?.nb,
            data?.caractSociologique?.reponseOPS?.PA?.nb,
            null
        );
        this.assignDE_AT_PA_OFRatioSpecific(
            this?.caracteristiqueSociologique?.isole,
            data?.caractSociologique?.isole,
            "nb",
            tmpDenominateurDE,
            data.caractSociologique?.enmennageRecent?.AT?.nb,
            data?.caractSociologique?.reponseOPS?.PA?.nb,
            null
        );
        this.assignDE_AT_PA_OFRatioSpecific(
            this.caracteristiqueSociologique?.couple,
            data.caractSociologique?.couple,
            "nb",
            tmpDenominateurDE,
            data.caractSociologique?.enmennageRecent?.AT?.nb,
            data.caractSociologique?.reponseOPS?.PA?.nb,
            null
        );
        this.assignDE_AT_PA_OFRatioSpecific(
            this.caracteristiqueSociologique?.monoparental,
            data.caractSociologique?.monoparental,
            "nb",
            tmpDenominateurDE,
            data.caractSociologique?.enmennageRecent?.AT?.nb,
            data.caractSociologique?.reponseOPS?.PA?.nb,
            null
        );

        let tmpenmennageRecent: any = this.addition(
            [
                data.caractSociologique?.enmennageRecentHorsQPV,
                data.caractSociologique?.enmennageRecentQPV,
            ],
            "nb"
        );

        this.assignDE_AT_PA_OFRatioSpecific(
            this.caracteristiqueSociologique?.inf60PcentPlafondPLUS,
            data.caractSociologique?.inf60PcentPlafondPLUS,
            "nb",
            null,
            tmpenmennageRecent?.AT?.nb,
            data.caractSociologique?.reponseOPS?.PA?.nb,
            null
        );
        this.assignDE_AT_PA_OFRatioSpecific(
            this.caracteristiqueSociologique?.inf60PcentPlafondPLUSHorsQPV,
            data.caractSociologique?.inf60PcentPlafondPLUSHorsQPV,
            "nb",
            null,
            data.caractSociologique?.enmennageRecentHorsQPV?.AT?.nb,
            data.caractSociologique?.reponseOPSHorsQPV?.PA?.nb,
            null
        );
        this.assignDE_AT_PA_OFRatioSpecific(
            this.caracteristiqueSociologique?.inf60PcentPlafondPLUSQPV,
            data.caractSociologique?.inf60PcentPlafondPLUSQPV,
            "nb",
            null,
            data.caractSociologique?.enmennageRecentQPV?.AT?.nb,
            data.caractSociologique?.reponseOPSQPV?.PA?.nb,
            null
        );
        this.assignDE_AT_PA_OFRatioSpecific(
            this.caracteristiqueSociologique?.inf40PcentPlafondPLUS,
            data.caractSociologique?.inf40PcentPlafondPLUS,
            "nb",
            null,
            tmpenmennageRecent?.AT?.nb,
            data.caractSociologique?.reponseOPS?.PA?.nb,
            null
        );
        this.assignDE_AT_PA_OFRatioSpecific(
            this.caracteristiqueSociologique?.inf40PcentPlafondPLUSHorsQPV,
            data.caractSociologique?.inf40PcentPlafondPLUSHorsQPV,
            "nb",
            null,
            data.caractSociologique?.enmennageRecentHorsQPV?.AT?.nb,
            data.caractSociologique?.reponseOPSHorsQPV?.PA?.nb,
            null
        );
        this.assignDE_AT_PA_OFRatioSpecific(
            this.caracteristiqueSociologique?.inf40PcentPlafondPLUSQPV,
            data.caractSociologique?.inf40PcentPlafondPLUSQPV,
            "nb",
            null,
            data.caractSociologique?.enmennageRecentQPV?.AT?.nb,
            data.caractSociologique?.reponseOPSQPV?.PA?.nb,
            null
        );
        this.assignDE_AT_PA_OFRatioSpecific(
            this.caracteristiqueSociologique?.inf20PcentPlafondPLUS,
            data.caractSociologique?.inf20PcentPlafondPLUS,
            "nb",
            null,
            tmpenmennageRecent?.AT?.nb,
            data.caractSociologique?.reponseOPS?.PA?.nb,
            null
        );
        this.assignDE_AT_PA_OFRatioSpecific(
            this.caracteristiqueSociologique?.inf20PcentPlafondPLUSHorsQPV,
            data.caractSociologique?.inf20PcentPlafondPLUSHorsQPV,
            "nb",
            null,
            data.caractSociologique?.enmennageRecentHorsQPV?.AT?.nb,
            data.caractSociologique?.reponseOPSHorsQPV?.PA?.nb,
            null
        );
        this.assignDE_AT_PA_OFRatioSpecific(
            this.caracteristiqueSociologique?.inf20PcentPlafondPLUSQPV,
            data.caractSociologique?.inf20PcentPlafondPLUSQPV,
            "nb",
            null,
            data.caractSociologique?.enmennageRecentQPV?.AT?.nb,
            data.caractSociologique?.reponseOPSQPV?.PA?.nb,
            null
        );
        this.assignDE_AT_PA_OFRatioSpecific(
            this.caracteristiqueSociologique?.APL,
            data.caractSociologique?.APL,
            "nb",
            null,
            data.caractSociologique?.enmennageRecent?.AT?.nb,
            data.caractSociologique?.reponseOPS?.PA?.nb,
            null
        );
        this.assignDE_AT_PA_OF(
            this.caracteristiqueSociologique?.pourcentagePremierQuartile,
            data.caractSociologique?.pourcentagePremierQuartile,
            "tx"
        );
        this.assignDE_AT_PA_OF(
            this.caracteristiqueSociologique?.pourcentagePremierQuartileHorsQPV,
            data.caractSociologique?.pourcentagePremierQuartileHorsQPV,
            "tx"
        );
        this.assignDE_AT_PA_OF(
            this.caracteristiqueSociologique?.pourcentagePremierQuartileQPV,
            data.caractSociologique?.pourcentagePremierQuartileQPV,
            "tx"
        );
        this.convertString2Percent(
            this.caracteristiqueSociologique?.pourcentagePremierQuartile,
            data?.nbTown
        );
        this.convertString2Percent(
            this.caracteristiqueSociologique?.pourcentagePremierQuartileHorsQPV,
            data?.nbTown
        );
        this.convertString2Percent(
            this.caracteristiqueSociologique?.pourcentagePremierQuartileQPV,
            data?.nbTown
        );

        /*******************************    Graphique *************************************/
        this.repartitionPatrimoine.lgt2000.PA = Number(
            data.repartitionPatrimoine?.lgt2000?.PA?.nb
        );
        this.repartitionPatrimoine.lgt2000EFG.PA = Number(
            data.repartitionPatrimoine?.lgt2000EFG?.PA?.nb
        );
        if (this.repartitionPatrimoine.lgt2000EFG.PA !== 0) {
            this.repartitionPatrimoine.lgt2000EFGpcent =
                (
                    (this.repartitionPatrimoine?.lgt2000EFG?.PA /
                        this.repartitionPatrimoine?.lgt2000?.PA) *
                    100
                ).toFixed(1) + "%";
        } else {
            this.repartitionPatrimoine.lgt2000EFGpcent = "-";
        }

        this.repartitionPatrimoine.lgt60A69.PA = Number(
            data.repartitionPatrimoine?.lgt60A69?.PA?.nb
        );
        this.repartitionPatrimoine.lgt60A69EFG.PA = Number(
            data.repartitionPatrimoine?.lgt60A69EFG?.PA?.nb
        );
        if (this.repartitionPatrimoine.lgt60A69EFG.PA !== 0) {
            this.repartitionPatrimoine.lgt60A69EFGpcent =
                (
                    (this.repartitionPatrimoine?.lgt60A69EFG?.PA /
                        this.repartitionPatrimoine?.lgt60A69?.PA) *
                    100
                ).toFixed(1) + "%";
        } else {
            this.repartitionPatrimoine.lgt60A69EFGpcent = "-";
        }

        this.repartitionPatrimoine.lgt70A79.PA = Number(
            data.repartitionPatrimoine?.lgt70A79?.PA?.nb
        );
        this.repartitionPatrimoine.lgt70A79EFG.PA = Number(
            data.repartitionPatrimoine?.lgt70A79EFG?.PA?.nb
        );
        if (this.repartitionPatrimoine.lgt70A79EFG.PA !== 0) {
            this.repartitionPatrimoine.lgt70A79EFGpcent =
                (
                    (this.repartitionPatrimoine?.lgt70A79EFG?.PA /
                        this.repartitionPatrimoine?.lgt70A79?.PA) *
                    100
                ).toFixed(1) + "%";
        } else {
            this.repartitionPatrimoine.lgt70A79EFGpcent = "-";
        }

        this.repartitionPatrimoine.lgt80A89.PA = Number(
            data.repartitionPatrimoine?.lgt80A89?.PA?.nb
        );
        this.repartitionPatrimoine.lgt80A89EFG.PA = Number(
            data.repartitionPatrimoine?.lgt80A89EFG?.PA?.nb
        );
        if (this.repartitionPatrimoine.lgt80A89EFG.PA !== 0) {
            this.repartitionPatrimoine.lgt80A89EFGpcent =
                (
                    (this.repartitionPatrimoine?.lgt80A89EFG.PA /
                        this.repartitionPatrimoine?.lgt80A89.PA) *
                    100
                ).toFixed(1) + "%";
        } else {
            this.repartitionPatrimoine.lgt80A89EFGpcent = "-";
        }

        this.repartitionPatrimoine.lgt90A99.PA = Number(
            data.repartitionPatrimoine?.lgt90A99?.PA?.nb
        );
        this.repartitionPatrimoine.lgt90A99EFG.PA = Number(
            data.repartitionPatrimoine?.lgt90A99EFG?.PA?.nb
        );
        if (this.repartitionPatrimoine.lgt90A99EFG.PA !== 0) {
            this.repartitionPatrimoine.lgt90A99EFGpcent =
                (
                    (this.repartitionPatrimoine?.lgt90A99EFG?.PA /
                        this.repartitionPatrimoine?.lgt90A99?.PA) *
                    100
                ).toFixed(1) + "%";
        } else {
            this.repartitionPatrimoine.lgt90A99EFGpcent = "-";
        }

        this.repartitionPatrimoine.lgtAvant1960.PA = Number(
            data.repartitionPatrimoine?.lgtAvant1960?.PA?.nb
        );
        this.repartitionPatrimoine.lgtAvant1960EFG.PA = Number(
            data.repartitionPatrimoine?.lgtAvant1960EFG?.PA?.nb
        );
        if (this.repartitionPatrimoine.lgtAvant1960.PA !== 0) {
            this.repartitionPatrimoine.lgtAvant1960EFGpcent =
                (
                    (this.repartitionPatrimoine?.lgtAvant1960EFG?.PA /
                        this.repartitionPatrimoine?.lgtAvant1960?.PA) *
                    100
                ).toFixed(1) + "%";
        } else {
            this.repartitionPatrimoine.lgtAvant1960EFGpcent = "-";
        }

        this.repartitionPatrimoine.moyenne.PA =
            Number(data.repartitionPatrimoine?.lgtAvant1960?.PA?.nb) +
            Number(data.repartitionPatrimoine?.lgt90A99?.PA?.nb) +
            Number(data.repartitionPatrimoine?.lgt80A89?.PA?.nb) +
            Number(data.repartitionPatrimoine?.lgt70A79?.PA?.nb) +
            Number(data.repartitionPatrimoine?.lgt60A69?.PA?.nb) +
            Number(data.repartitionPatrimoine?.lgt2000?.PA?.nb);
        this.repartitionPatrimoine.moyenneEFG.PA =
            Number(data.repartitionPatrimoine?.lgtAvant1960EFG?.PA?.nb) +
            Number(data.repartitionPatrimoine?.lgt90A99EFG?.PA?.nb) +
            Number(data.repartitionPatrimoine?.lgt80A89EFG?.PA?.nb) +
            Number(data.repartitionPatrimoine?.lgt70A79EFG?.PA?.nb) +
            Number(data.repartitionPatrimoine?.lgt60A69EFG?.PA?.nb) +
            Number(data.repartitionPatrimoine?.lgt2000EFG?.PA?.nb);
        if (this.repartitionPatrimoine.moyenne.PA !== 0) {
            this.repartitionPatrimoine.moyenneEFGpcent =
                (
                    (this.repartitionPatrimoine?.moyenneEFG?.PA /
                        this.repartitionPatrimoine?.moyenne?.PA) *
                    100
                ).toFixed(1) + "%";
        } else {
            this.repartitionPatrimoine.moyenneEFGpcent = "-";
        }

        let tmpCaracteristiqueHlmT1T2 = this.addition(
            [data.caracteristiqueHlm?.T1, data.caracteristiqueHlm?.T2],
            "nb"
        );
        this.assignDE_AT_PA_OFRatioWithTauxRotationTauxCroissanceONdivide3(
            this.caracteristiqueHlm?.T1T2,
            tmpCaracteristiqueHlmT1T2,
            "nb",
            data.caracteristiqueHlm?.nombre,
            "nb"
        );
        let tmpCaracteristiqueHlmT4T5Plus = this.addition(
            [data.caracteristiqueHlm?.T4, data.caracteristiqueHlm?.T5Plus],
            "nb"
        );
        this.assignDE_AT_PA_OFRatioWithTauxRotationTauxCroissanceONdivide3(
            this.caracteristiqueHlm?.T4T5Plus,
            tmpCaracteristiqueHlmT4T5Plus,
            "nb",
            data.caracteristiqueHlm?.nombre,
            "nb"
        );
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/classFiche.ts